import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useAuthProvider } from 'react-admin';
import CustomBackdrop from '@/components/common/custom-backdrop/custom-backdrop';
import { REDIRECT_TO_URL_QUERY_PARAMS } from '@/utils/CONST';

const GetTokenFromUrl = () => {
    const authProvider = useAuthProvider();
    let { refreshToken }: any = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const getTokenAndRedirect = async () => {
        if (refreshToken && authProvider) {
            await authProvider.refreshToken({
                refreshToken,
            });

            const searchParams = new URLSearchParams(location.search);
            const navigateTo = searchParams.get(REDIRECT_TO_URL_QUERY_PARAMS);

            navigate(`${navigateTo}`);
        }
    };

    useEffect(() => {
        getTokenAndRedirect();
    }, []);

    return <CustomBackdrop />;
};

export default GetTokenFromUrl;
